// extracted by mini-css-extract-plugin
export default {"label":"NftKindLabel_label__KnZaJ","pnftLabel":"NftKindLabel_pnftLabel__bRmOy","pnftLabelRow":"NftKindLabel_pnftLabelRow__gDrjU"};